export const DuplicateIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-5.0 -20.0 110.0 135.0"
      fill="#fff"
    >
      <g>
        <path d="m73.957 66.668v-45.836c0-4.0195-3.2734-7.293-7.293-7.293l-45.832 0.003907c-4.0195 0-7.293 3.2734-7.293 7.293v45.832c0 4.0195 3.2734 7.293 7.293 7.293h45.832c4.0195 0 7.293-3.2734 7.293-7.293zm-54.168 0 0.003907-45.836c0-0.57422 0.46875-1.043 1.043-1.043h45.832c0.57422 0 1.043 0.46875 1.043 1.043v45.832c0 0.57422-0.46875 1.043-1.043 1.043h-45.836c-0.57422 0-1.043-0.46875-1.043-1.043z" />
        <path d="m83.332 26.043c-1.7266 0-3.125 1.3984-3.125 3.125v50c0 0.57422-0.46875 1.043-1.043 1.043l-49.996-0.003907c-1.7266 0-3.125 1.3984-3.125 3.125 0 1.7266 1.3984 3.125 3.125 3.125h50c4.0195 0 7.293-3.2734 7.293-7.293l-0.003907-49.996c0-1.7266-1.3984-3.125-3.125-3.125z" />
      </g>
    </svg>
  );
};
